// App.tsx — Root component, chỉ layout + router
import { Header, Footer, ScrollToTop, FloatingContact } from './components'
import AppRouter from './app/router'

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <FloatingContact />
      <Header />
      <main style={{ flex: 1 }}>
        <AppRouter />
      </main>
      <Footer />
    </div>
  )
}

export default App
